const ENTRY = 'script[type="module"][src*="/assets/"]'

/** The running build's entry script (`/assets/index-<hash>.js`); null in dev, where nothing is hashed. */
export function runningEntry(): string | null {
  return document.querySelector<HTMLScriptElement>(ENTRY)?.getAttribute('src') ?? null
}

/** The entry script the server currently ships, read from a fresh index.html. */
export async function latestEntry(): Promise<string | null> {
  const res = await fetch('/', { cache: 'no-store', headers: { accept: 'text/html' } })
  if (!res.ok || !res.headers.get('content-type')?.includes('text/html')) return null
  const doc = new DOMParser().parseFromString(await res.text(), 'text/html')
  return doc.querySelector<HTMLScriptElement>(ENTRY)?.getAttribute('src') ?? null
}
